import { QueryClient, useQuery } from "@tanstack/react-query";
import clientApi from "@/api-client/client";
import { ApiResponse } from "@/types/api";
import { Server } from "@/types/entities";
import { getQueryKey } from "@key.ai/constants";
import { KickStartStep } from "@/types";
import { useSession } from "next-auth/react";

export const useServerQuery = ({
  serverId,
  initialData
}: {
  serverId: string;
  initialData?: Server;
}) => {
  const queryKey = getQueryKey("SERVER_INFO", { serverId });
  const { status } = useSession();
  const fetchServer = async () => {
    const { data } = await clientApi.get(`api/v1/servers/${serverId}`).json<ApiResponse<Server>>();
    return data;
  };

  return useQuery<Server>({
    queryKey: [queryKey],
    queryFn: fetchServer,
    initialData,
    retry: false,
    enabled: status === "authenticated" && !!serverId
  });
};

interface Onboarding {
  onboarding: KickStartStep[];
  isOnboard: boolean;
}

export const queryUpdateServer = (
  queryClient: QueryClient,
  serverId: string,
  onboarding: Onboarding
) => {
  const queryKey = getQueryKey("SERVER_INFO", { serverId });

  queryClient.setQueryData([queryKey], (server: Server) => {
    if (!server) return server;
    return Object.assign(server, onboarding);
  });
};
